module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iIzAzOUJFNSIgZD0iTTE3IDI5aDE0djJIMTd6bS00IDRoMjJ2MkgxM3ptLTQgNGgzMHYySDl6bS00IDRoMzh2Mkg1eiIvPjxwYXRoIGZpbGw9IiM4MUQ0RkEiIGQ9Ik0zNSAxM2MtLjQgMC0uOCAwLTEuMi4xQzMyLjkgOC41IDI4LjkgNSAyNCA1Yy00LjEgMC03LjYgMi41LTkuMiA2SDE0Yy00LjQgMC04IDMuNi04IDhzMy42IDggOCA4aDIxYzMuOSAwIDctMy4xIDctN3MtMy4xLTctNy03eiIvPjxwYXRoIGZpbGw9IiMwMzlCRTUiIGQ9Ik0yOCAyMWMwLTIuMi0xLjgtNC00LTRzLTQgMS44LTQgNHY2aDh2LTZ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/entering_heaven_alive.svg
// module id = 4174
// module chunks = 0